// extracted by extract-css-chunks-webpack-plugin
module.exports = {"next":"j8btfZkUMYGX03vSKF82","prev":"B8S_mYeVm152I_eCUlkf","arrow":"N9U4NxsI5EtX3f73Xwzz"};